<template>
<div class="chapter">
<div class="inner_page">
<div class="_--black-opening-page">
<p class="cn"><span epub:type="pagebreak" id="page7" title="7"> <a id="_idTextAnchor003"></a> </span></p>
<p class="_ct" id="_idParaDest-6">Making Your Own<br/>Herbal Remedies</p>
<p class="drop-bulletedrule-above"><span class="_idGenDropcap-1">Y</span>our kitchen cupboard contains herbs and spices with valuable healing properties that can be used to treat and prevent common health problems. Most of us already use them in cooking, but they can also be thought of as friends that help us maintain wellbeing or treat common ailments. Using them can be as simple as incorporating them into your diet by making a cup of herbal tea. </p>
<p class="tx">Because we are using culinary herbs and spices, you can be sure that none of them are intrinsically harmful, but there are still a few safety considerations to be taken into account. </p>
<ul>
<li class="bl-sb">Remember that anyone can be allergic to anything. </li>
<li class="bl">Larger amounts of some herbs and spices are not compatible with prescription medicines. Always check with your healthcare professional before using herbal remedies on a regular basis. </li>
<li class="bl">Always consult a medical practitioner if you have any acute or persistent health concerns. </li>
<li class="bl"><span epub:type="pagebreak" id="page8" title="8">Make sure that you have looked up the method of preparation and the safe dosages. </span></li>
<li class="bl">Do not take large amounts of any herb for an extended period of time.</li>
</ul>
<p class="a-head">Tools Needed</p>
<ul>
<li class="bl-sb">Saucepan (not copper or aluminium)</li>
<li class="bl">Double boiler (or a bowl over a pan of boiling water)</li>
<li class="bl">Kettle</li>
<li class="bl">Muslin</li>
<li class="bl">Kitchen scales</li>
<li class="bl">Measuring jug</li>
<li class="bl">Bottles and jars</li>
<li class="bl">Pestle and mortar</li>
</ul>
<p class="a-head">Herbal Preparations</p>
<p class="txni">Herbs may be prepared in a variety of ways for internal and external use, so let’s look at some basic methods.</p>
<p class="contents _idGenParaOverride-1"><a href="#/Contents#_idTextAnchor000">[contents]</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HKWH-2.vue?03f1a354